/**
 * Component for showing progress during multi-step wizards
 */

import { Component, Input } from '@angular/core';
import { CurrentStepInfo } from '../wizard/typings/models';

@Component({
    selector: 'cl-step-counter',
    templateUrl: './StepCounterView.html'
})
export class StepCounterComponent {
    public static $name: string = 'clStepCounter';

    @Input() public currentStepMetadata: CurrentStepInfo;
    @Input() public hideTotalCount: boolean;
}
